<app-journal-list [journalItems]="journalItems" [showUserName]="false"></app-journal-list>
